import React from 'react';
import type { SearchInventoryItem } from './types';
import { labelClassName, readOnlyInputClassName } from './types';

/**
 * Read-only security identity for the trade-entry form. LR-495: takes just the
 * display fields (a structural subset of SearchInventoryItem) instead of the whole
 * item, so amend can pass values derived from the booked position without
 * fabricating a synthetic inventory item. Create passes its selected inventory item
 * (which structurally satisfies this), amend passes the booked security.
 */
type SecurityDisplay = Pick<SearchInventoryItem, 'symbolId' | 'shortName' | 'sedol' | 'isin'>;

interface SecurityDetailsSectionProps {
  security: SecurityDisplay;
}

export const SecurityDetailsSection: React.FC<SecurityDetailsSectionProps> = ({
  security,
}) => {
  return (
    <div className="p-6 grid grid-cols-1 md:grid-cols-4 gap-4">
      <div>
        <label className={labelClassName}>
          Security
        </label>
        <input
          type="text"
          value={security.symbolId}
          readOnly
          className={readOnlyInputClassName}
        />
      </div>
      <div>
        <label className={labelClassName}>
          Description
        </label>
        <input
          type="text"
          value={security.shortName || ''}
          readOnly
          className={readOnlyInputClassName}
        />
      </div>
      <div>
        <label className={labelClassName}>
          SEDOL
        </label>
        <input
          type="text"
          value={security.sedol || ''}
          readOnly
          className={readOnlyInputClassName}
        />
      </div>
      <div>
        <label className={labelClassName}>
          ISIN
        </label>
        <input
          type="text"
          value={security.isin || ''}
          readOnly
          className={readOnlyInputClassName}
        />
      </div>
    </div>
  );
};
